import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/technological',
    name: 'technological-dashboard',
    title: 'Dashboard Tecnologico',
    component: () => import('../views/technological-dashboard.vue'),
    children: [
      {
        path: '/technological/home',
        name: 'technological-dashboard',
        meta: {
          title: 'dashboard',
        },
        component: () => import('../views/tec/Home.vue'),
      },
      {
        path: '/technological/documentation',
        name: 'documentation',
        meta: {
          title: 'documentation',
        },
        component: () => import('../views/tec/Documentation.vue'),        
      },
      {
        path: '/technological/apis',
        name: 'apis',
        meta: {
          title: 'APIs',
        },
        component: () => import('../views/tec/Apis.vue'),        
      },
      {
        path: '/technological/transactions',
        name: 'transactions',
        meta: {
          title: 'transactions',
        },
        component: () => import('../views/tec/Transactions.vue'),
      },
      {
        path: '/technological/roadmap',
        name: 'roadmap',
        meta: {
          title: 'roadmap',
        },
        component: () => import('../components/tec/Roadmap.vue'),
      },
      {
        path: '/technological/support',
        name: 'support',
        meta: {
          title: 'support',
        },
        component: () => import('../views/tec/Support.vue'),
      },
      {
        path: '/technological/profile',
        name: 'profile',
        meta: {
          title: 'profile',
        },
        component: () => import('../views/tec/Profile.vue'),
      },
      {
        path: '/technological/monitor',
        name: 'monitor',
        meta: {
          title: 'monitor',
        },
        component: () => import('../components/tec/Monitor.vue'),
      },
      {
        path: '/technological/solutions',
        name: 'monitor',
        meta: {
          title: 'solutions',
        },
        component: () => import('../views/tec/Solutions.vue'),
      },
    ]
  },
  {
    path: '/bussiness',
    name: 'bussiness-dashboard',
    component: () => import('../views/bussiness-dashboard.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
